import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGroupChatContext } from '../../context/groupchatContext';

const ProviderLandingPage = () => {

    const groupChatContext = useGroupChatContext();
    const navigate = useNavigate();

    const {authData, setAuthData} = useMemo(() => ({
        authData: groupChatContext.authData,
        setAuthData: groupChatContext.setAuthData
    }));

    const data = window.location.search.split('?data=')[1];

    useEffect(()=>{
        if(data){
            const decodedData = decodeURIComponent(data);
            const parsedData = JSON.parse(decodedData);
            localStorage.clear();
            localStorage.setItem('base_url', JSON.stringify(parsedData.organization_setting));
            localStorage.setItem('auth', decodedData);
            setAuthData(parsedData);
            navigate('/')
        }
    }, [data])

    return (
        <div className="flex justify-center items-center h-screen">
            <p className="text-xl">Loading...</p>
        </div>
    );
};

export default ProviderLandingPage;
